import { router, useLocalSearchParams } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import BrandedButton from '@/components/buttons/BrandedButton';
import FormWrapper from '@/components/forms/FormWrapper';
import NumeratedBulletList from '@/components/NumeratedBulletList';
import Text from '@/components/Text';
import { NpoOnboardingRoutes } from '@/constants/enums/NpoOnboardingRoutes';
import { SIGN_IN_BUTTON_BOTTOM } from '@/constants/layout';
import { useAuth } from '@/contexts/authContext';
import { i18n } from '@/utils/i18n';

const StartSetup = () => {
  const { whereToGoAfterIntro } = useLocalSearchParams<{
    whereToGoAfterIntro: NpoOnboardingRoutes;
  }>();
  const { state: authState } = useAuth();
  const type = authState.signUpData?.loginEmail?.type;
  let firstNavigation = type === 'CHARITIES' ? NpoOnboardingRoutes.NINE_NINETY_FORM : NpoOnboardingRoutes.GENERAL;

  const startProfileList = [
    i18n.t('sign_in.nonProfit.intro.start_profile.list.form990'),
    i18n.t('sign_in.nonProfit.intro.start_profile.list.organizationImages'),
    i18n.t('sign_in.nonProfit.intro.start_profile.list.financialStatement'),
    i18n.t('sign_in.nonProfit.intro.start_profile.list.thirdPartyAudit'),
    i18n.t('sign_in.nonProfit.intro.start_profile.list.impactStudy'),
    i18n.t('sign_in.nonProfit.intro.start_profile.list.churchBylaws')
  ];

  return (
    <FormWrapper keyboardVerticalOffset={0}>
      <View style={styles.container}>
        <View style={styles.body}>
          <Text>{i18n.t('sign_in.nonProfit.intro.start_profile.subtitle')}</Text>
          <Text fontWeight="700" style={styles.title}>
            {i18n.t('sign_in.nonProfit.intro.start_profile.what_you_will_need')}
          </Text>
          <NumeratedBulletList list={startProfileList} />
          <Text>{i18n.t('sign_in.nonProfit.intro.start_profile.files')}</Text>
        </View>

        <BrandedButton
          style={styles.button}
          onPress={() => {
            if (router.canDismiss()) router.dismissAll();
            if (whereToGoAfterIntro) {
              router.replace({
                pathname: whereToGoAfterIntro
              });
            } else {
              router.replace({
                pathname: firstNavigation
              });
            }
          }}>
          {i18n.t('sign_in.nonProfit.intro.start_profile.start_profile_setup')}
        </BrandedButton>
      </View>
    </FormWrapper>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1
  },

  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between'
  },

  loader: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },

  body: {
    flexDirection: 'column',
    gap: 25
  },

  title: {
    fontSize: 22,
    color: 'black'
  },

  button: {
    marginBottom: SIGN_IN_BUTTON_BOTTOM
  }
});

export default StartSetup;
